export default __webpack_public_path__ + "static/media/maximize.ffafbc5c.svg";